"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Infographic() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return;
}